import React from 'react'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import Fade from '@material-ui/core/Fade'

import { makeStyles, useTheme } from '@material-ui/core'
import { styles } from './helpIndex.styles'

import { HelpIndexEntryVM } from './helpPanel.model'
import { DataTableSkeleton } from '@globaleris/ui.library'
import { TimeoutError } from '../../../../../errors/specific/timeout/timeoutError'

interface HelpIndexProps {
  index: HelpIndexEntryVM[] | undefined
  onClickIndexEntry: (entryPath: HelpIndexEntryVM) => void
}

export const HelpIndex: React.FC<HelpIndexProps> = ({ index, onClickIndexEntry }) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  if (index === undefined) return <DataTableSkeleton />
  return index.length ? (
    <Fade in>
      <List>
        {index.map(indexEntry => (
          <ListItem button onClick={() => onClickIndexEntry(indexEntry)} key={indexEntry.path}>
            <ListItemText disableTypography secondary={indexEntry.subtitle || indexEntry.title}>
              <Typography variant="h2" component="h2" color="primary">
                {indexEntry.title}
              </Typography>
            </ListItemText>
          </ListItem>
        ))}
      </List>
    </Fade>
  ) : (
    <div className={classes.helpNotFoundRoot}>
      <TimeoutError />
    </div>
  )
}
